<template>
  <el-dialog
    append-to-body
    width="550px"
    title=""
    destroy-on-close
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-loading="loading"
    element-loading-text="图片上传中…"
  >
    <template #title>
      <div class="el-dialog-title">{{ title }}</div>
    </template>
    <el-form
      class="staff-from"
      ref="elFormDom"
      label-width="80px"
      label-position="top"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      hide-required-asterisk
    >
      <aiTe ref="aiTeRef" v-model="aiteIdList" @change="aiTeChange"></aiTe>
      <div :class="{'padding-b10':aiteObjList.length}">
        <el-tag size="small" v-for="tag in aiteObjList" @close="tagClose(tag.id)" :key="tag.name" closable>
          {{ tag.name }}
        </el-tag>
      </div>
      <el-form-item label="" prop="comment">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model.trim="form.data.comment"
          :placeholder="`请输入${status == 1 ? '同意' : '拒绝'}理由`"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="comment" v-if="status == 1">
        <template #label> 快捷回复 <span style="color: #999"></span> </template>
        <el-radio-group
          v-model="checkboxGroup1"
          @change="change"
        >
          <el-radio-button v-for="s in str" :label="s" :key="s">{{
            s
          }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="附件" prop="file">
        <template #label> 附件 <span style="color: #999"></span> </template>
        <uploadfile
          :loading.sync="form.loading"
          :fileList="fileList"
          @setfileList="(files) => (fileList = files)"
        ></uploadfile>
      </el-form-item>
      <el-form-item label="" prop="image" class="imgWrap">
        <template #label>
          图片 <span style="color: #999">(最多选择9张图片)</span>
        </template>
        <uploadimg
          :loading.sync="form.loading"
          :fileListImg="fileListImg"
          @imgChange="(files) => (fileListImg = files)"
        ></uploadimg>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button @click="showGzFunc" v-if="parentShow&&showSign()">盖章</el-button>
        <el-button
          type="primary"
          :loading.sync="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
    <!-- 盖章 -->
    <el-dialog
      append-to-body
      destroy-on-close	
      custom-class="no-header-dialog" 
      top="2vh"
      title=""
      :visible.sync="signVisible"
      :before-close="resetSign"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      >
      <sign @signSubmit="signSubmit" :dataInfo="dataInfo" :flowFileList="flowFileList" :signCompany="signCompany" :signet="signet" @cancel='signVisible = false' ref="gzRef"></sign>
    </el-dialog>
  </el-dialog>

</template>

<script>
import sign from "@/components/sign/index.vue";
import { mixinTable } from "@/mixins/table.js";
import { getStorage } from "@/storage";
import uploadfile from "@/components/uploadfile.vue";
import uploadimg from "@/components/uploadimg.vue";
import { generateUUID } from "@/util/util.js";
import aiTe from "@/components/aiTe.vue";
export default {
  name: "MyComment",
  mixins: [mixinTable],
  components: { uploadfile, uploadimg, sign,aiTe},
  props: { title: String, status: Number,parentShow:Boolean },
  data() {
    return {
      token: getStorage("token"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          id: "",
          comment: "",
          picture: [],
          files: [],
        },
        rules: {},
      },
      fileList: [],
      fileListImg: [],
      str: ["同意", "确认", "情况属实", "已复核", "已办理" , "已入库" ,"已出库"],
      str2: ["同意", "确认", "情况属实", "已复核", "已办理", "已入库" ,"已出库"],
      checkboxGroup1: "",
      //盖章
      signVisible:false,
      dataInfo:null,
      fields:[], // 字段信息
      flowFileList:[], // 流程附件列表
      signCompany:[], // 盖章公司信息
      signet:[], // 申请的章信息
      aiteIdList:[],
      aiteObjList:[],
    };
  },
  methods: {
    tagClose(id) {
      this.aiteIdList = this.aiteIdList.filter((item) => item !== id);
      this.aiteObjList = this.aiteObjList.filter((item) => item.id !== id);
      this.$refs.aiTeRef.personObjList = this.aiteObjList;
    },
    aiTeChange(val) {
      this.aiteObjList = val;
      console.log('收到','aiteObjList',this.aiteObjList)
    },
    showSign() {
      if((window.location.href.indexOf(".jszhr.test") || window.location.href.indexOf("localhost")) && this.dataInfo && this.dataInfo.approval_id == 261 ) {
        return true
      }else if(window.location.href.indexOf(".jszhr.com") && this.dataInfo && (this.dataInfo.approval_id == 97 || this.dataInfo.approval_name == "印章使用申请") ) {
        return true
      }else {
        return false
      }
    },
    resetSign() {
      this.signVisible = false;
    },
    showGzFunc() {
      this.signVisible = true;
    },
    change(e) {
      this.form.data.comment = e;
    },
    getDetail(row, id) {
      if (!!row.id) {
        this.isChange = true;
        this.$nextTick(() => {
          this.form.data.id = id;
        });
      }
      this.dataInfo = row;
      this.fields = row.form_content.fields;
      //附件
      let attachField = this.fields.find(item => item.type == "attach");
      if(attachField) {
        this.flowFileList = JSON.parse(attachField.__config__.defaultValue);
        this.flowFileList = this.flowFileList.map(item =>{
          return {
            name: item.name,
            url: item.url,
            pdfId: generateUUID(),
          }
        });
        this.flowFileList = this.flowFileList.filter(item =>item.url.endsWith('.pdf'));
      }
      //盖章公司信息
      let companyField = this.fields.find(item => item.type == "company");
      if(companyField) {
        this.signCompany = JSON.parse(companyField.__config__.defaultValue);
      }
      //申请的章
      let signetField = this.fields.find(item => item.type == "signet");
      if(signetField) {
        this.signet = JSON.parse(signetField.__config__.defaultValue);
      }
    },
    reset(done) {
      this.isChange = false;
      this.checkboxGroup1 = "";
      this.fileList = [];
      this.fileListImg = [];
      this.aiteIdList = [];
      this.aiteObjList = [];
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let _fileList = this.fileList.map((v) => {
            return {
              name: v.name,
              file: v.url,
            };
          });
          let _fileListImg = this.fileListImg.map((v) => v.url);
          if (
            _fileList.length == 0 &&
            _fileListImg.length == 0 &&
            this.form.data.comment == ""
          ) {
            return this.$message.warning("请输入");
          }
          let at_employees = this.aiteObjList.length>0?this.aiteObjList.map(item => {
              return {
                employee_id:item.id,
                name:item.name
              }
            }):[]
          let _params = {
            id: this.form.data.id,
            comment: this.form.data.comment,
            picture: JSON.stringify(_fileListImg),
            files: JSON.stringify(_fileList),
            status: this.status,
            at_employees:JSON.stringify(at_employees),
          };
          if(this.dataInfo.cur_flow.is_expense == 1 && this.dataInfo.expenseList && this.dataInfo.expenseList.length>0 ) {
            let expenseList = this.dataInfo.expenseList.map(j =>{
              return {
                ...j,
                amount:j.canMoney
              }
            });
            let expense_ = {
              payAmount:expenseList[0].payAmount,
              expenseList:expenseList,
            };
            _params.expense = JSON.stringify(expense_);
          }
          if(at_employees.length) {
            let str = '';
            at_employees.forEach(e => {
              str += `@${e.name} `
            });
            _params.comment = str +' ' +this.form.data.comment;
          }
          this.form.loading = true;
          this.$http
            .post("/admin/employeeApproval/deal", _params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    signSubmit(val) {
      console.log(val,'signSubmit')
      let list = val.result.map((item,index) =>{
        return {
          name: item.pdf_name,
          url:item.new_pdf_file
        }
      });
      this.fileList = [...this.fileList,...list];
    }
  },
};
</script>

<style lang="scss" scoped>
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.imgWrap ::v-deep .avatar-uploader-icon {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
::v-deep .no-header-dialog .el-dialog__header{
  display: none;
}
::v-deep .no-header-dialog .el-dialog__body{
  padding: 20px 20px 30px 20px;
}
.padding-b10{
  padding-bottom: 10px;
}
</style>